import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import SideNav from './Partials/SideNav';
import { qprService } from '../../../../Services';
import { useLocation, useNavigate } from 'react-router-dom';

const SubmitForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { qpr_id, qh } = location.state;
  window.history.pushState(null, null, location.href);
    window.onpopstate = function () {
      window.history.go(1);
  };
  const [submitted, setSubmitted] = useState(false);

  const [input, setInput] = useState({
    comment: '',
  });

  const ref = useRef([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const submitForm = () => {
    input.submit_status = 1;
    qprService.submit(input, qpr_id).then(res => {
      setSubmitted(false);
      if(res.status == 1) {
        navigate("/user/home");
      } 
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    submitForm();
  }
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>{qh}</h5>
              </div>
              <div className='row mt-4'>
                <div className='col-md-4'>
                  <SideNav />
                </div>
                <div className='col-md-8'>
                  <div className='card border-info' style={{"borderTop": "3px solid"}}>
                    {/* <div className='card-header'><h6>Response to technical expert</h6></div> */}
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                          <div className='singel-form'>
                            <label>Any other comments (Also you can provide the link of images/videos/tools/code/questionnaire developed after uploading it to drive):</label>
                            <textarea name='comment' value={input.comment && input.comment} ref={r => {ref.current['comment'] = r}} onChange={handleChange}></textarea>
                          </div>
                          <hr/>
                          <p className="form-message"></p>
                          <div className="singel-form text-center">
                            <button type={submitted? "button": "submit"} className="main-btn btn-info disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Submit</span>}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SubmitForm;